/* global fbq:true */
import {connect} from 'react-redux'
import RegisterForm from './RegisterForm'
import ProfileSetupForm from './ProfileSetupForm'
import {registerBusinessRequest, registerRequest, setIsRegistered} from 'actions'
import {referralRequest, changeReferralData} from 'actions/auth'
import styles from './style.css'
import * as mpRegister from 'mixpanel/register'

class Register extends React.Component {
  componentWillMount () {
    this.props.dispatch(setIsRegistered(false))
    let {ref} = this.props.location.query
    let {referral} = this.props.data.auth
    // if the new code is different from old referral in state
    if (ref && ref !== referral.code) {
      this.props.dispatch(referralRequest(ref))
    } else {
      this.props.dispatch(changeReferralData({}))
    }
    mpRegister.registrationStart({})
  }

  componentDidMount () {
    // Facebook Pixel
    fbq('init', '1661541900796850')
    fbq('track', 'Lead')

    // Google Adwords Conversion Tracking
    // The CDATA tag is required for testing the track plugin in local browser
    window.google_trackConversion({
      google_conversion_id: 950464113,
      google_conversion_label: 'XMqECJva4mQQ8dybxQM',
      google_remarketing_only: false
    })
  }

  render () {
    let {dispatch} = this.props
    let {ref} = this.props.location.query
    let {currentlySending, error, isRegistered} = this.props.data.moka
    let {referral} = this.props.data.auth
    return (
      <div>
        {!isRegistered
          ? <div>
            <center>
              <div className={`${styles['mk-register-header']} row`}>
                <div className={`${styles['title-container']} text-center col-xs-6 col-xs-offset-3`}>
                  <div className={`col-xs-12 ${styles['title-register']}`}>
                  MokaPOS brings your business to the next level!
                </div>
                  <div className={`${styles['description-container']} text-center col-xs-12 col-lg-4`}>
                    <img src='https://s3-ap-southeast-1.amazonaws.com/image.mokapos.com/growth/backoffice/register/contract.svg' />
                    <p className={`${styles['sub-title']}`}>No Contract</p>
                    <p>You don’t need to sign an agreement contract. You can cancel your subscription at any time.</p>
                  </div>
                  <div className={`${styles['description-container']} text-center col-xs-12 col-lg-4`}>
                    <img src='https://s3-ap-southeast-1.amazonaws.com/image.mokapos.com/growth/backoffice/register/unlimited-product.svg' />
                    <p className={`${styles['sub-title']}`}>Unlimited Products</p>
                    <p>You’ll have access to a wide variety of features, and the many more features to come.</p>
                  </div>
                  <div className={`${styles['description-container']} text-center col-xs-12 col-lg-4`}>
                    <img src='https://s3-ap-southeast-1.amazonaws.com/image.mokapos.com/growth/backoffice/register/free-support.svg' />
                    <p className={`${styles['sub-title']}`}>Free Support</p>
                    <p>Got a question? Simply drop us a message or give us a ring to get all the answers you need from Moka.</p>
                  </div>
                </div>
              </div>
              <div className={`${styles.root} row`}>
                <RegisterForm
                  dispatch={dispatch}
                  history={this.props.history}
                  onSubmit={this.handleRegisterSubmit}
                  btnText={'Create Account'}
                  error={error}
                  currentlySending={currentlySending}
                  showChapcha={this.props.params.chapcha} />
              </div>
            </center>
            {ref && referral.code && <div className='mk-referral-banner ng-scope'>
              <div className='col-md-12'>
                <img alt='Telkomsel' className='img img-responsive' src={referral.logo_url} />
              </div>
              </div>}
          </div>
          : <section className={'profile-setup-form '}>
            <div className='container'>
              <div className='row'>
                <div className='col-md-7 col-lg-7 col-sm-12'>
                  <div className={styles['mk-section-header']}>PROFILE SETUP</div>
                </div>
              </div>
              <div className='row'>
                <div className='col-md-7 col-lg-7 col-sm-12'>
                  <ProfileSetupForm
                    dispatch={dispatch}
                    history={this.props.history}
                    onSubmit={this.handleProfileSetupSubmit}
                    businessTypes={this.props.data.moka.businessTypesState}
                    businessCategories={this.props.data.moka.businessCategoriesState}
                    error={error}
                    currentlySending={currentlySending} />
                  {ref && referral.code && <div className='mk-referral-banner'>
                    <img alt='Telkomsel' className='img img-responsive' src={referral.logo_url} />
                  </div>}
                </div>
              </div>
            </div>
          </section>
        }
      </div>
    )
  }

  handleRegisterSubmit = (values) => {
    let {email, password, confpassword} = values
    this.props.dispatch(registerRequest({email, password, confpassword}))
  }

  handleProfileSetupSubmit = (values) => {
    let {moka, auth: {referral: {id}}} = this.props.data
    let {formRegState} = moka
    this.props.dispatch(
      registerBusinessRequest(
        {
          business: {
            business_type_id: values.businessType,
            business_category_id: values.businessCategory,
            name: values.businessName,
            address: values.businessAddress,
            city: values.businessCity,
            province: values.businessProvince,
            postal_code: values.businessPostalCode
          },
          user: {
            email: formRegState.email,
            password: formRegState.password,
            password_confirmation: formRegState.confpassword,
            first_name: values.userFirstName,
            last_name: values.userLastName,
            phone: '0' + values.userPhone
          },
          referral_id: id,
          agent: 'browser'
        }
      )
    )
  }
}

Register.propTypes = {
  data: React.PropTypes.object,
  history: React.PropTypes.object,
  dispatch: React.PropTypes.func,
  location: React.PropTypes.object
}

function select (state) {
  return {
    data: state
  }
}

export default connect(select)(Register)



// WEBPACK FOOTER //
// ./app/pages/Register/Register.js